import { exit } from "process";
import { RecordCache } from "../Tasks/RecordCache";
import { DataQuery } from "../utils/DataQuery";
import { DataRecord } from "../utils/DataRecord";

export interface ParticipantType
{
	id: string;
	uuid: string;
	status: string;
	phase: number;
	site_loc_id: string;
	first_name: string;
	last_name: string;
	birthdate: Date;
	last_login_dt: Date;
	first_login_dt: Date;
	tasks_pending: number;
	screenfailed_reason: string;
	withdraw_reason: string;
	enrolled_dt: Date;
	enrolled_by: Date;
	[key: string]: string | Date | number | boolean;
};

// Cache for loaded participants
let globalParticipantCache: RecordCache<DataRecord<ParticipantType>> = new RecordCache();

export class Participant
{
	/** Reference to the loaded participant */
	participantDataRecord: DataRecord<ParticipantType> | undefined;

	/** A debounce time for saving / updating task counts. */
	taskCountUpdateTimer: NodeJS.Timeout | undefined;

	/** Reset the participant cache, remove all cached records. */
	static clearParticipantCache()
	{
		globalParticipantCache = new RecordCache();
	}

	static async searchForParticipant(searchText: string): Promise<Participant[]>
	{
		// Load from server
		const list: Participant[] = [];

		const queryText = `id=${searchText}`;
		const results = await DataQuery.instance().executeQuery("Participant", queryText);
		for (const record of results)
		{
			const part = new Participant();
			part.participantDataRecord = record;
			list.push(part);
		}

		return list;
	}

	async loadByUUID(uuid: string): Promise<boolean>
	{
		// Check the cache first
		const cacheResults = globalParticipantCache.find({ uuid: uuid });
		if (cacheResults && cacheResults.length > 0)
		{
			this.participantDataRecord = cacheResults[0];
			this.updateParticipantTaskCount();
			return true;
		}

		// Search by UUID instead of ID
		let records = await DataQuery.instance().executeQuery("Participant", "uuid=" + uuid);
		if (records && records.length > 0)
		{
			this.participantDataRecord = records[0];
			globalParticipantCache.add(this.participantDataRecord, 1000);
			this.updateParticipantTaskCount();
			return true;
		}

		return false;
	}

	/** Load a participant with a given id
	 *  Note this is not the same as the uuid field.
	 */
	async loadById(id: string): Promise<boolean>
	{
		if (/[0-9\-]{6,12}/.test(id))
		{
			return this.loadByUUID(id);
		}

		const part = await DataQuery.instance().executeQueryById("Participant", id);
		if (part)
		{
			this.participantDataRecord = part;
			this.updateParticipantTaskCount();
			return true;
		} else
		{
			console.error("Critical error in updateParticipantTaskCount, unable to find participant " + id);
			return false;
		}
	}


	/**
	 * Update the number of tasks pending for this user by checking
	 * the list of tasks in the database and then save the record to the
	 * server if the number has changed
	 *
	 * @returns Number of pending tasks
	 */
	updateParticipantTaskCount()
	{
		/** Brian:  Turning this function off.  Moved to the server
		https://brians.atlassian.net/jira/software/c/projects/LAINA/issues/LAINA-1546
		*/

		/*

		if (this.taskCountUpdateTimer)
			clearTimeout(this.taskCountUpdateTimer)

		this.taskCountUpdateTimer = setTimeout(() => {
			if (!this.participantDataRecord) return 0;
			if (!this.participantDataRecord.data) return 0;

			let oldCount = this.participantDataRecord.data.tasks_pending;
			const queryText = `Tasks;participant_id=${this.participantDataRecord.data.uuid}&task_status=P`;

			DataQuery.instance().executeCountQueryByText(queryText)
			.then((counter) => {
				if (!this.participantDataRecord) return 0;
				if (!this.participantDataRecord.data) return 0;

				this.participantDataRecord.data.tasks_pending = counter;
				this.participantDataRecord.saveIfNeeded();
				return this.participantDataRecord.data.tasks_pending;
			})
		}, 500);

		*/
	}

	constructor()
	{

	}

};
